'use strict';

angular.module('ntmApp').factory('ComplexCriteria', ['ComplexCondition', 'ReportService', 'FlashService', 'ComplexSearchConstants',
    function (ComplexCondition, ReportService, FlashService, ComplexSearchConstants) {

    function ComplexCriteria() {

        var self = this;
        var DEFAULT_CONDITIONS_COUNT = 1;

        var conditions = [];

        self.loadFieldTypes = function (reportId) {

            return ReportService.GetReportFilters(reportId).then(function (response) {
                self.fieldTypes = response.data.filters;
            });

        };

        self.setConditions = function (conditionList) {
            conditions = conditionList;
        };

        self.setConditionsFromJson = function (conditionsJson) {

          var conditionList = [];
          var objectFromConditionsJSON = JSON.parse(conditionsJson);

          objectFromConditionsJSON.forEach(function (conditionObject) {

            var condition = new ComplexCondition();

            condition.closingParenthesis = conditionObject.closingParenthesis;
            condition.openingParenthesis = conditionObject.openingParenthesis;
            condition.conditionalOperator = conditionObject.conditionalOperator;
            condition.from = conditionObject.from;
            condition.to = conditionObject.to;
            condition.multiSelectSettings = conditionObject.multiSelectSettings;
            condition.selectedOperator = conditionObject.selectedOperator;

            condition.selectedFieldType = self.fieldTypes.find(fieldType =>fieldType.fieldName === conditionObject.selectedFieldType.fieldName);

            if (!condition.selectedFieldType.properties)
              condition.selectedFieldType.properties = new Object();

            if (Array.isArray(conditionObject.value)) {
              var newValues = [];
              conditionObject.value.forEach(function (value) {
                var newValue = condition.selectedFieldType.values.find(fieldValue => fieldValue.id === value.id);
                if (newValue)
                  newValues.push({ id: newValue.id, value: newValue.value });
              });

              condition.value = newValues;
            } else if (conditionObject.value && conditionObject.value.id) {
                var newValue = condition.selectedFieldType.values.find(fieldValue => fieldValue.id === conditionObject.value.id);
                if (newValue)
                  condition.value = newValue;
            } else if ((new Date(conditionObject.value) !== "Invalid Date") && !isNaN(new Date(conditionObject.value)) && condition.selectedFieldType.type === 'DATE') {
                condition.value = new Date(conditionObject.value);

                if(conditionObject.from)
                  condition.from = new Date(conditionObject.from);
                if(conditionObject.to)
                  condition.to = new Date(conditionObject.to);
            } else {
                condition.value = conditionObject.value;
            }

            conditionList.push(condition);
          });

          conditions = conditionList;
        };

        self.getConditions = function () {
            return conditions;
        };

        self.getConditionsJSON = function () {
          var conditionList = [];

          conditions.forEach(function (conditionObject) {

            var conditionJSON = new ComplexCondition();

            conditionJSON.closingParenthesis = conditionObject.closingParenthesis;
            conditionJSON.openingParenthesis = conditionObject.openingParenthesis;
            conditionJSON.conditionalOperator = conditionObject.conditionalOperator;
            conditionJSON.from = conditionObject.from;
            conditionJSON.to = conditionObject.to;
            conditionJSON.multiSelectSettings = conditionObject.multiSelectSettings;
            conditionJSON.selectedFieldType.fieldId = conditionObject.selectedFieldType.fieldId;
            conditionJSON.selectedFieldType.fieldName = conditionObject.selectedFieldType.fieldName;
            conditionJSON.selectedOperator = conditionObject.selectedOperator;
            conditionJSON.value = conditionObject.value;

            conditionList.push(conditionJSON);
            });

          return JSON.stringify(conditionList);
        };

        self.isFirst = function (condition) {
            return conditions.indexOf(condition) === 0;
        };

        self.isLast = function (condition) {
            return conditions.indexOf(condition) === conditions.length - 1;
        };

        self.remove = function (condition) {
            conditions.remove(condition);

            if (conditions.length > 0) {
                conditions[conditions.length - 1].conditionalOperator = 'AND';
            }
        };

        self.addCondition = function (condition) {
            if (condition) {
                conditions.splice(conditions.indexOf(condition) + 1, 0, new ComplexCondition());
            } else {
                conditions.push(new ComplexCondition());
            }            
        };

        self.clearConditions = function () {
          self.setConditions([]);
          createDefaultEmptyConditions();
        }

        self.getPreview = function () {
            
            var previewText = "";

            conditions.forEach(function (condition, $index) {
                previewText += condition.asText(conditions.length === $index + 1, conditions.length);
            });

            return previewText.trimRight();
        };

        self.getWarningMessage = function () {

            var warningMessage = "";

            var requiredFieldsFilled = conditions.every(areAllRequiredFieldsFilled);

            if (!requiredFieldsFilled) {
                warningMessage += "All filter inputs are required";
            }

            if (isParenthesisMismatch()) {
                warningMessage += " Opening parenthesis count must equal closing parenthesis count.";
            }

            return warningMessage;
        };

        self.getSearchParams = function (selectedReport) {

            var params = {
                reportId: selectedReport.id,
                reportName: selectedReport.name
            };

            var conditionItems = [];

            self.getConditions().forEach(function (filterCondition) {

                var conditionList = [];

                if (filterCondition.selectedFieldType.type === 'CHECKBOXLIST') {

                    filterCondition.value.forEach(function (val, index) {
                        var multiSelectCondition = angular.copy(filterCondition);

                        if (filterCondition.value.length === 1) {
                            multiSelectCondition.conditionalOperator = 'AND';
                        } else {
                            multiSelectCondition.conditionalOperator = filterCondition.selectedOperator.value === ComplexSearchConstants.Operators.EQUALS.value ? 'OR' : 'AND';
                        }

                        if (index === 0 && filterCondition.value.length > 1) {
                            multiSelectCondition.multiselectOpeningParenthesis = '(';
                        }

                        if (index + 1 === filterCondition.value.length && filterCondition.value.length > 1) {
                            multiSelectCondition.multiselectClosingParenthesis = ')';
                            multiSelectCondition.conditionalOperator = filterCondition.conditionalOperator;
                        }

                        multiSelectCondition.multiselectValue = val[filterCondition.multiSelectSettings.idProp];

                        conditionList.push(multiSelectCondition);
                    });
                } else {
                    conditionList.push(filterCondition);
                }

                conditionList.forEach(function (condition, index) {

                    var conditionItem = {
                        field: condition.selectedFieldType.properties.key || condition.selectedFieldType.fieldName,
                        paren: condition.multiselectOpeningParenthesis || condition.openingParenthesis || condition.multiselectClosingParenthesis || condition.closingParenthesis,
                        andOr: condition.conditionalOperator
                    };

                    if (index == 0 && conditionList.length == 1) {
                      conditionItem.paren = (condition.multiselectOpeningParenthesis || "") + (condition.openingParenthesis || "") + (condition.multiselectClosingParenthesis || "") + (condition.closingParenthesis || "");
                    } else if (index === 0 && conditionList.length >1) {
                      conditionItem.paren = (condition.openingParenthesis || "") + (condition.multiselectOpeningParenthesis || "");
                    } else if (index + 1 === filterCondition.value.length && conditionList.length > 1) {
                      conditionItem.paren = (condition.multiselectClosingParenthesis || "") + (condition.closingParenthesis || "");
                    } else if (index != 0 && index + 1 != filterCondition.value.length && conditionList.length > 1) {
                      conditionItem.paren = (condition.multiselectOpeningParenthesis || "") + (condition.multiselectClosingParenthesis || "");
                    }

                    if (!condition.isRange() && !condition.isDateSpecific()) {
                        conditionItem.value = condition.multiselectValue || condition.getValue();
                        conditionItem.operator = condition.selectedOperator.value;
                    } else {

                        if (!condition.isDateSpecific()) {
                            conditionItem.value = condition.from;
                            conditionItem.highValue = condition.to;
                            conditionItem.operator = condition.selectedOperator.value;
                        } else {

                            if (condition.isDateSpecificRange()) {
                                var range = condition.getDateSpecificRange();
                                conditionItem.value = range.from;
                                conditionItem.highValue = range.to;
                                conditionItem.operator = ComplexSearchConstants.Operators.BETWEEN.value;
                            } else {
                                conditionItem.value = condition.getSingleSpecificDate();
                                conditionItem.operator = conditionItem.value === null ? ComplexSearchConstants.Operators.ISNULL.value : ComplexSearchConstants.Operators.EQUALS.value;
                            }
                        }
                    }

                    conditionItems.push(conditionItem);
                });

                
            });

            params.dataFilter = conditionItems;
            params.filterPreviewText = self.getPreview();

            return params;
        };

        function areAllRequiredFieldsFilled(condition) {
            return condition.selectedFieldType &&
                   condition.selectedFieldType.name &&
                   condition.selectedOperator &&
                   condition.selectedOperator.value &&
                   (condition.value || (condition.from && condition.to) || condition.isDateSpecific()) &&
                   (condition.conditionalOperator || self.isLast(condition));
        }

        function isParenthesisMismatch() {

            if (conditions.length < 3) {
                return false;
            }

            var openingParenthesisCount = 0;
            var closingParenthesisCount = 0;

            conditions.forEach(function (condition) {

                if (condition.openingParenthesis) {
                    openingParenthesisCount++;
                }

                if (condition.closingParenthesis) {
                    closingParenthesisCount++;
                }
            });

            return openingParenthesisCount !== closingParenthesisCount;
        }

        function createDefaultEmptyConditions() {
            
            for (var i = 0; i < DEFAULT_CONDITIONS_COUNT; i++) {
                self.addCondition();
            }
        }

        function initialize() {
            createDefaultEmptyConditions();
        }

        initialize();

    }

    return (ComplexCriteria);
}]);
